import { IFrequency } from '@common/interfaces/frequency'
import { combineReducers } from 'redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.LIST_REQUEST:
        return [...state, action.type]
      case actions.LIST_SUCCESS:
      case actions.LIST_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  list(state: IFrequency[] = [], action: IAction): IFrequency[] {
    switch (action.type) {
      case actions.LIST_SUCCESS:
        return action.data as IFrequency[]
      default:
        return state
    }
  },
})
